// extracted by mini-css-extract-plugin
export default {"menu":"Navigation_menu__qQ4fb","bodyOverlay":"Navigation_bodyOverlay__SDSjN"};